'use strict';
var util = require('../util');

var core = {
    appVersion: '8.1.0'
};

if (util.osName === 'ios') {
    core.getHealthData = function(opts) {
        if (!opts) return;
        // 目前支持的类型
        var typeList = [1];
        var type = opts.quantityType;
        var fail = opts.fail;
        // valid
        if (~typeList.indexOf(type)) {
            _handleDate(opts) && this._send('getHealthData', opts);
        } else {
            typeof fail == 'function' && fail('type error');
        }

        function _handleDate(opts) {
            var start = opts.startDate;
            var end = opts.endDate || new Date();
            var fail = opts.fail;

            start = +new Date(start);
            end = +new Date(end);
            if (start < end) {
                // 单位：秒
                opts.startDate = Math.round(start / 1000);
                opts.endDate = Math.round(end / 1000);
                return true;
            } else {
                typeof fail == 'function' && fail('date error');
            }
        }
    };
    core.prompt = function(opt) {
        if (!opt.placeholder) {
            opt.placeholder = '';
        }
        this._send('prompt', opt);
    };
}

module.exports = core;



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@dp/dpapp/lib/patch/patch-8.1.0.js
// module id = 558
// module chunks = 0